import * as React from "react";
import {
  Route,
  RouteComponentProps,
  Switch,
  withRouter,
} from "react-router-dom";

/**
 * Containers
 */
import UserContainer from "../../containers/user/UserContainer.connect";
import history from "../../shared/services/history";
import { isValidResetScrollPosition } from "../../shared/services/url";
import AccessDenied from "../common/error/accessDenied/AccessDenied";
import Error from "../common/error/error/Error";
import NotFound from "../common/error/notFound/NotFound";

/**
 * Route component
 */
class AppRoutes extends React.Component<RouteComponentProps, {}> {
  constructor(props: RouteComponentProps) {
    super(props);
  }

  public componentDidMount() {
    history.listen((location, action) => {
      if (isValidResetScrollPosition(location, this.props.location, action)) {
        window.scrollTo(0, 0);
      }
    });
  }

  public render() {
    return (
      <Switch>
        <Route path="/" exact={true} component={UserContainer} />
        <Route
          path="/error"
          exact={true}
          render={() => <Error hasBackButton={false} />}
        />
        <Route
          path="/notFound"
          render={() => <NotFound hasBackButton={false} />}
        />
        <Route
          path="/accessDenied"
          render={() => <AccessDenied hasBackButton={false} />}
        />
        <Route path="/invitation/sent" exact={true} component={UserContainer} />
        <Route path="/:orgname" component={UserContainer} />
        <Route path="/tutorial" component={UserContainer} />
      </Switch>
    );
  }
}

export default withRouter(AppRoutes);
